import { useQuery, UseQueryOptions } from 'react-query';
import cbsSubscriptionsService from '~/src/services/api/cbsSubscriptionsService';
import { composeQueryOpts } from '../../entities/utils';
import { APIError } from '~/src/utils/error';
import { useCurrentOrgFprint } from '~/src/entities/user';

export interface PaymentMethodIframeUrlResponse {
  payment_method_iframe_url: string;
}

export const usePaymentMethodIframeUrl = (
  options: UseQueryOptions<PaymentMethodIframeUrlResponse, APIError> = {},
) => {
  const orgFprint = useCurrentOrgFprint();
  const enabled = Boolean(orgFprint);

  return useQuery<PaymentMethodIframeUrlResponse, APIError>(
    composeQueryOpts(options, {
      queryKey: enabled
        ? ['paymentMethodIframeUrl', orgFprint]
        : ['paymentMethodIframeUrl'],
      queryFn: () =>
        orgFprint
          ? cbsSubscriptionsService.getPaymentMethodIframeUrl(orgFprint)
          : Promise.reject(new Error('Organization fingerprint missing')),
      enabled,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }),
  );
};
